import { render } from "./TrainingVideos.vue?vue&type=template&id=45e79a8c"
import script from "./TrainingVideos.vue?vue&type=script&lang=js"
export * from "./TrainingVideos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__